import { router } from "react-query-kit";
import { hardReloadAfterMutation } from "../rqk/hardReloadAfterMutation";
import { invalidateQueriesAfterMutation } from "../rqk/invalidateQueriesAfterMutation";
import { showMultiStepLoaderOnMutating } from "../rqk/showMultiStepLoaderOnMutating";
import { authService } from "./backend";
import type { LoginInput, ResetPasswordInput, SignupInput } from "./schema";
import { getCurrentSession } from "./utils";

export const authQueries = router("auth", {
  getCurrentSession: router.query({
    fetcher: () => getCurrentSession(),
  }),
  loginWithBasicCredentials: router.mutation({
    mutationFn: (input: LoginInput) =>
      authService.loginWithBasicCredentials({ data: input }),
    use: [
      showMultiStepLoaderOnMutating({
        loadingStates: [
          { text: "连线到认证服务器..." },
          { text: "校验登录凭证..." },
          { text: "获取用户信息..." },
          { text: "检查用户权限..." },
          { text: "生成会话..." },
        ],
      }),
      invalidateQueriesAfterMutation([["auth"]]),
      hardReloadAfterMutation(),
    ],
  }),
  logout: router.mutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      location.reload();
    },
    use: [
      invalidateQueriesAfterMutation([["auth"]]),
      hardReloadAfterMutation(),
    ],
  }),
  signup: router.mutation({
    mutationFn: (input: SignupInput) =>
      authService.signupWithBasicCredentials({ data: input }),
  }),
  resetPassword: router.mutation({
    mutationFn: (input: ResetPasswordInput) =>
      authService.resetPassword({ data: input }),
  }),
});
